export default __webpack_public_path__ + "static/media/user-avatar-white.30fe4107.svg";